import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../AxiosInterceptor/axiosInterceptor";
import { GROUP_BY_YEAR_ALL } from "../../Table/TableQueryColumn";

const initialState = {
    data: {
        Account: '',
        PlanCode: '',
        PlanCode5: '',
        PlanCodePALevel: '',
        PlanYear: '',
        StartDate: '',
        EndDate: '',
        EndDateForPlanYear: '',
        Carrier: '',
        PlanType: '',
        BenCD: '',
        RankNum: '',
        Group: '',
        totalCount: 0,
        page: 0,
        pageSize: 50,
        sortOrder: "asc",
        columnName: "Carrier",
        collectionName: "Group By Year All"
    },
    dataAll: "",
    search: true,
    error: false,
    isSearchClicked: false,
    searchTriggered: true,
    loading: false,
    clear: false,
    showAll: false,
    inputError: {
        Account: false,
        Group: false,
        PlanCode5: false,
        Carrier: false,
    }
}

export const getGroupByYearAllData = createAsyncThunk('data/getGroupByYearAllData',
    async (data, { rejectWithValue }) => {
        try {
            let queryGroupByPlanYear =
                `query GetEligibleGroupByPlanYearAllDetails{
                GetEligibleGroupByPlanYearAllDetails(
                pageNumber:${data.page + 1},
                pageSize:${data.pageSize},
                sortOrder:"${data.sortOrder}",
                columnName:"${data.columnName}",
                collectionName:"Group By Year All"
                ${data.Group ? `,group: "${data.Group}"` : ""}
                ${data.PlanCode5 ? `,plancode5: "${data.PlanCode5}"` : ""}
                ${data.Carrier ? `,carrier: "${data.Carrier}"` : ""}
                ${data.Account ? `,account: "${data.Account}"` : ""}
                `;

            queryGroupByPlanYear += GROUP_BY_YEAR_ALL

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryGroupByPlanYear, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

export const getGroupByYearAllDataDownloadAll = createAsyncThunk('data/getGroupByYearAllDataDownloadAll',
    async (data, { rejectWithValue }) => {
        try {
            let queryGroupByPlanYear =
                `query GetAllEligibleGroupByPlanYearAllDetails{
                    GetAllEligibleGroupByPlanYearAllDetails(
                collectionName:"Group By Year All",
                ${data.Group ? `,group: "${data.Group}"` : ""}
                ${data.PlanCode5 ? `,plancode5: "${data.PlanCode5}"` : ""}
                ${data.Carrier ? `,carrier: "${data.Carrier}"` : ""}
                ${data.Account ? `,account: "${data.Account}"` : ""}
                `;

            queryGroupByPlanYear += GROUP_BY_YEAR_ALL

            const response = await axiosInstance.post(process.env.REACT_APP_MNR_DETAIL,
                JSON.stringify({ query: queryGroupByPlanYear, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

const groupByYearAllSlice = createSlice({
    name: 'groupByYearAll',
    initialState,
    reducers: {
        currentData: (state, action) => {
            state.data = action.payload
        },
        clearData: (state) => {
            state.data = initialState.data;
            state.search = true;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        resetData: (state) => {
            state.data = initialState.data;
            state.search = false;
            state.inputError = initialState.inputError;
            state.error = initialState.error;
        },
        updateSearch: (state, action) => {
            state.search = action.payload;
        },
        searchClicked: (state, action) => {
            state.isSearchClicked = action.payload;
            state.error = initialState.error;
        },
        clearTable: (state, action) => {
            state.isSearchClicked = action.payload;
        },
        searchTriggered: (state, action) => {
            state.searchTriggered = action.payload;
        },
        updateInputError: (state, action) => {
            state.inputError = action.payload
        },
        resetError: (state, action) => {
            state.inputError = initialState.inputError;
        },
        resetToaster: (state, action) => {
            state.error = initialState.error;
        },
        showAll: (state, action) => {
            state.showAll = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getGroupByYearAllData.pending, (state) => {
                //state.loading = true;
                state.error = false;
            })
            .addCase(getGroupByYearAllData.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                state.data.totalCount = response.data.data.GetEligibleGroupByPlanYearAllDetails.totalCount;
                state.data.tableData = response.data.data.GetEligibleGroupByPlanYearAllDetails.data;
            })
            .addCase(getGroupByYearAllData.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
            .addCase(getGroupByYearAllDataDownloadAll.pending, (state) => {
                state.loading = true;
                state.error = false;
            })
            .addCase(getGroupByYearAllDataDownloadAll.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.error = false;
                state.loading = false;
                //state.data.totalCount = response.data.data.GetMemberPlanYearAllDetails.totalCount;
                state.data.tableData = response.data.data.GetAllEligibleGroupByPlanYearAllDetails.data;
            })
            .addCase(getGroupByYearAllDataDownloadAll.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
            })
    }
})

export const { currentData, clearData, updateSearch, searchClicked, clearTable,
    searchTriggered, updateInputError, resetError, resetToaster, showAll } = groupByYearAllSlice.actions;
export default groupByYearAllSlice.reducer